// src/components/Header.jsx
import React from "react";
import  "../Styles/Header.css"; // make sure to create this CSS file for styling
import logo from "../Assest/newcluster.png"; // replace with your actual logo path
import { useState } from "react";



const Header = ({ isLoggedIn = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

// count the words frequency 






 return (
  <header className="header">
    {/* Logo */}
    <div className="logo">
      <a href="/">
        <img src={logo} alt="ClusterClear Logo" />
      </a>
    </div>

    {!isLoggedIn && (
      <>
        {/* Navigation */}
        <nav className={`nav-links ${menuOpen ? "mobile-open" : ""}`}>
          <a
            href="/#how-it-works"
            onClick={() => setMenuOpen(false)}
          >
            How it Works
          </a>

          <a
            href="/#about-us"
            onClick={() => setMenuOpen(false)}
          >
            About Us
          </a>

          <a
            href="/#contact-us"
            onClick={() => setMenuOpen(false)}
          >
            Contact Us
          </a>

          {/* Mobile Buy Now */}
          <a
            href="/product"
            className="mobile-buy-link"
            onClick={() => setMenuOpen(false)}
          >
            Get Your Wristband →
          </a>
        </nav>

        {/* Right Side */}
        <div className="nav-right">
          {/* Desktop */}
          <div className="auth-buttons">
            <a href="/login">
              <button className="login">
                My Wristband
              </button>
            </a>

            <a href="/product">
              <button className="signup">
                Buy Now
              </button>
            </a>
          </div>

          {/* Mobile */}
          <div className="mobile-header">
            <a href="/login">
              <button className="login mobile-login">
                My Wristband
              </button>
            </a>

            <div
              className={`hamburger ${menuOpen ? "open" : ""}`}
              onClick={toggleMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </>
    )}
  </header>
);
};

export default Header;;